import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import Header from './Header';
import PromoBanner from './PromoBanner';
import HeroSection from './HeroSection';
import HowItWorksSection from './HowItWorksSection';
import BenefitsSection from './BenefitsSection';
import RestaurantsExamplesSection from './RestaurantsExamplesSection';
import FeaturesSection from './FeaturesSection';
import UseCasesSection from './UseCasesSection';
import TestimonialsSection from './TestimonialsSection';
import PlansSection from './PlansSection';
import FAQSection from './FAQSection';
import Footer from './Footer';

// Modern, clean theme configuration inspired by Linear, Stripe, Notion
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2563eb', // Modern blue
      light: '#60a5fa',
      dark: '#1e40af',
    },
    secondary: {
      main: '#8b5cf6', // Purple accent
      light: '#a78bfa',
      dark: '#7c3aed',
    },
    background: {
      default: '#ffffff',
      paper: '#fafafa',
    },
    text: {
      primary: '#0f172a',
      secondary: '#64748b',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '10px 24px',
          fontSize: '1rem',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export function StartPage() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box className="StartPage" sx={{bgcolor: 'background.default'}}>
        <Header />
        <PromoBanner />
        <HeroSection />
        <HowItWorksSection />
        <BenefitsSection />
        <RestaurantsExamplesSection />
        <FeaturesSection />
        <UseCasesSection />
        <TestimonialsSection />
        <PlansSection />
        <FAQSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}